import BaseAction from "../base-action";
import {ActionTypeEnum} from "../../base/training-literals";

class ExplodeScene extends BaseAction {
    centerPoint;
    unit;

    constructor(props = {}) {
        super(props);
        this.actionType = ActionTypeEnum.EXPLODE_SCENE;
        this.centerPoint = props.centerPoint || [0, 0, 0];
        this.unit = props.unit || 0;
    }

    get(props = {}) {
        return {
            type: this.actionType,
            centerPoint: props.centerPoint || this.centerPoint,
            unit: props.unit || this.unit,
            duration: props.duration || this.duration
        }
    }
}

export default ExplodeScene;